$(document).ready(function(){
  $(".menu-logo-close-icon svg").on("click",function(){
    $(".header summary.header__icon").trigger('click');
  })
  $('.drawer-item-slider').slick({
  slidesToShow: 1.54,
  slidesToScroll: 1,
  arrows:false,
  accessibility: false,
  infinite:false,
  responsive: [
  {
    breakpoint: 577,
      settings: {
      slidesToShow: 1.45  
      }
  }
  ]
});
  $('.multirow_slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows:false,
  accessibility: false,
  infinite:false,
    dots:true   
 
});

   

  if ($(window).width() < 992) {
    var lis = $(".slider-collection ul.product-grid li"); // Get all the li elements
    for (var i = 0; i < lis.length; i += 4) {
        lis.slice(i, i + 4).wrapAll("<div class='responsive-2-slide'></div>");
  }
  }
 
   $('.slider-collection ul.product-grid').slick({
  slidesToShow: 4,
  slidesToScroll: 4,
  arrows: true,
  accessibility: false,
     infinite:false,
     dots:true,
     appendArrows: $('.start-with-best-seller .slick-slider-nav'),
    appendDots: $('.start-with-best-seller .slick-slider-dots'),
    prevArrow: "<button class='slick-prev btn btn-white rounded-circle'><svg xmlns='http://www.w3.org/2000/svg' width='49' height='49' viewBox='0 0 49 49' fill='none'><path d='M15.7929 25.151C15.4024 24.7604 15.4024 24.1273 15.7929 23.7367L22.1569 17.3728C22.5474 16.9823 23.1805 16.9823 23.5711 17.3728C23.9616 17.7633 23.9616 18.3965 23.5711 18.787L17.9142 24.4438L23.5711 30.1007C23.9616 30.4912 23.9616 31.1244 23.5711 31.5149C23.1805 31.9054 22.5474 31.9054 22.1569 31.5149L15.7929 25.151ZM34.5 25.4438H16.5V23.4438H34.5V25.4438Z' fill='#1B1B1B'/><circle cx='24' cy='24' r='23.5' transform='matrix(-1 0 0 1 48.5 0.443848)' stroke='#1B1B1B'/></svg></button>",
    nextArrow: "<button class='slick-next btn btn-white rounded-circle'><svg xmlns='http://www.w3.org/2000/svg' width='49' height='49' viewBox='0 0 49 49' fill='none'><path d='M33.2071 25.151C33.5976 24.7604 33.5976 24.1273 33.2071 23.7367L26.8431 17.3728C26.4526 16.9823 25.8195 16.9823 25.4289 17.3728C25.0384 17.7633 25.0384 18.3965 25.4289 18.787L31.0858 24.4438L25.4289 30.1007C25.0384 30.4912 25.0384 31.1244 25.4289 31.5149C25.8195 31.9054 26.4526 31.9054 26.8431 31.5149L33.2071 25.151ZM14.5 25.4438H32.5V23.4438H14.5V25.4438Z' fill='#1B1B1B'/><circle cx='24.5' cy='24.4438' r='23.5' stroke='#1B1B1B'/></svg></button>",
     responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
       
      }
    },
    {
      breakpoint: 360,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        
       
      }
    }
    
  ]
});

 $('.pdp-customer-slider ul.product-grid').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: true,
  accessibility: false,
     infinite:false,
     dots:true,
     appendArrows: $('.pdp-customer-slider .slick-slider-nav'),
    appendDots: $('.pdp-customer-slider .slick-slider-dots'),
    prevArrow: "<button class='slick-prev btn btn-white rounded-circle'><svg xmlns='http://www.w3.org/2000/svg' width='49' height='49' viewBox='0 0 49 49' fill='none'><path d='M15.7929 25.151C15.4024 24.7604 15.4024 24.1273 15.7929 23.7367L22.1569 17.3728C22.5474 16.9823 23.1805 16.9823 23.5711 17.3728C23.9616 17.7633 23.9616 18.3965 23.5711 18.787L17.9142 24.4438L23.5711 30.1007C23.9616 30.4912 23.9616 31.1244 23.5711 31.5149C23.1805 31.9054 22.5474 31.9054 22.1569 31.5149L15.7929 25.151ZM34.5 25.4438H16.5V23.4438H34.5V25.4438Z' fill='#1B1B1B'/><circle cx='24' cy='24' r='23.5' transform='matrix(-1 0 0 1 48.5 0.443848)' stroke='#1B1B1B'/></svg></button>",
    nextArrow: "<button class='slick-next btn btn-white rounded-circle'><svg xmlns='http://www.w3.org/2000/svg' width='49' height='49' viewBox='0 0 49 49' fill='none'><path d='M33.2071 25.151C33.5976 24.7604 33.5976 24.1273 33.2071 23.7367L26.8431 17.3728C26.4526 16.9823 25.8195 16.9823 25.4289 17.3728C25.0384 17.7633 25.0384 18.3965 25.4289 18.787L31.0858 24.4438L25.4289 30.1007C25.0384 30.4912 25.0384 31.1244 25.4289 31.5149C25.8195 31.9054 26.4526 31.9054 26.8431 31.5149L33.2071 25.151ZM14.5 25.4438H32.5V23.4438H14.5V25.4438Z' fill='#1B1B1B'/><circle cx='24.5' cy='24.4438' r='23.5' stroke='#1B1B1B'/></svg></button>",
     responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
       
        
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
       
      }
    }
    
    
  ]
});
  
  $('.multicolumn_slider').slick({
  slidesToShow: 6,
  slidesToScroll: 6,
  arrows: true,
  accessibility: false,
     infinite:false,
     dots:true,
     appendArrows: $('.multicolumn .slick-slider-nav'),
    appendDots: $('.multicolumn .slick-slider-dots'),
    prevArrow: "<button class='slick-prev btn btn-white rounded-circle'><svg xmlns='http://www.w3.org/2000/svg' width='49' height='49' viewBox='0 0 49 49' fill='none'><path d='M15.7929 25.151C15.4024 24.7604 15.4024 24.1273 15.7929 23.7367L22.1569 17.3728C22.5474 16.9823 23.1805 16.9823 23.5711 17.3728C23.9616 17.7633 23.9616 18.3965 23.5711 18.787L17.9142 24.4438L23.5711 30.1007C23.9616 30.4912 23.9616 31.1244 23.5711 31.5149C23.1805 31.9054 22.5474 31.9054 22.1569 31.5149L15.7929 25.151ZM34.5 25.4438H16.5V23.4438H34.5V25.4438Z' fill='#1B1B1B'/><circle cx='24' cy='24' r='23.5' transform='matrix(-1 0 0 1 48.5 0.443848)' stroke='#1B1B1B'/></svg></button>",
    nextArrow: "<button class='slick-next btn btn-white rounded-circle'><svg xmlns='http://www.w3.org/2000/svg' width='49' height='49' viewBox='0 0 49 49' fill='none'><path d='M33.2071 25.151C33.5976 24.7604 33.5976 24.1273 33.2071 23.7367L26.8431 17.3728C26.4526 16.9823 25.8195 16.9823 25.4289 17.3728C25.0384 17.7633 25.0384 18.3965 25.4289 18.787L31.0858 24.4438L25.4289 30.1007C25.0384 30.4912 25.0384 31.1244 25.4289 31.5149C25.8195 31.9054 26.4526 31.9054 26.8431 31.5149L33.2071 25.151ZM14.5 25.4438H32.5V23.4438H14.5V25.4438Z' fill='#1B1B1B'/><circle cx='24.5' cy='24.4438' r='23.5' stroke='#1B1B1B'/></svg></button>",
     responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll:2,
       
      }
    },
    {
      breakpoint: 360,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        
       
      }
    }
    
  ]
});

  if($('.multicolumn .slick-slider-dots .slick-dots li').length == 1){
   $('.multicolumn .slick-slider-dots').hide(); 
  }else{
      $('.multicolumn .slick-slider-dots').show();   
  }
  
  $(window).on('load', function() {
     if($('.multicolumn .slick-slider-dots .slick-dots li').length == 1){
   $('.multicolumn .slick-slider-dots').hide(); 
  }else{
      $('.multicolumn .slick-slider-dots').show();   
  }
  });
  
  $(window).resize(function() {
     if($('.multicolumn .slick-slider-dots .slick-dots li').length == 1){
   $('.multicolumn .slick-slider-dots').hide(); 
  }else{
      $('.multicolumn .slick-slider-dots').show();   
  }
  });
  $(".product .product-quantity-select").on("change",function(){
   
 $(this).parents(".product").find(".price-per-item__container input").val($(this).val());
    $(this).parents(".product").find(".price-per-item__container button").last().click();    
  });

  $(".bundle-product-collection-hp .product-card-wrapper").hover(function () {
    var newheight=$(this).outerHeight() - $(this).find('.card__inner.ratio').height() -17;
    $(this).css("background",'linear-gradient(to top, #fff '+newheight+'px, #CDCDCD 0px');
}, 
function () {
    $(this).css("background",'#fff');
});
  if ($(window).width() < 1200) {
    
     $('.bundle-product-collection-hp ul.product-grid').slick({
         slidesToShow: 3,
  slidesToScroll: 1,
       arrows: true,
       accessibility: false,
     infinite:true,
     dots:true,
       centerMode:true,
       appendArrows: $('.bundle-product-collection-hp .slick-slider-nav'),
    appendDots: $('.bundle-product-collection-hp .slick-slider-dots'),
    prevArrow: "<button class='slick-prev btn btn-white rounded-circle'><svg xmlns='http://www.w3.org/2000/svg' width='49' height='49' viewBox='0 0 49 49' fill='none'><path d='M15.7929 25.151C15.4024 24.7604 15.4024 24.1273 15.7929 23.7367L22.1569 17.3728C22.5474 16.9823 23.1805 16.9823 23.5711 17.3728C23.9616 17.7633 23.9616 18.3965 23.5711 18.787L17.9142 24.4438L23.5711 30.1007C23.9616 30.4912 23.9616 31.1244 23.5711 31.5149C23.1805 31.9054 22.5474 31.9054 22.1569 31.5149L15.7929 25.151ZM34.5 25.4438H16.5V23.4438H34.5V25.4438Z' fill='#1B1B1B'/><circle cx='24' cy='24' r='23.5' transform='matrix(-1 0 0 1 48.5 0.443848)' stroke='#1B1B1B'/></svg></button>",
    nextArrow: "<button class='slick-next btn btn-white rounded-circle'><svg xmlns='http://www.w3.org/2000/svg' width='49' height='49' viewBox='0 0 49 49' fill='none'><path d='M33.2071 25.151C33.5976 24.7604 33.5976 24.1273 33.2071 23.7367L26.8431 17.3728C26.4526 16.9823 25.8195 16.9823 25.4289 17.3728C25.0384 17.7633 25.0384 18.3965 25.4289 18.787L31.0858 24.4438L25.4289 30.1007C25.0384 30.4912 25.0384 31.1244 25.4289 31.5149C25.8195 31.9054 26.4526 31.9054 26.8431 31.5149L33.2071 25.151ZM14.5 25.4438H32.5V23.4438H14.5V25.4438Z' fill='#1B1B1B'/><circle cx='24.5' cy='24.4438' r='23.5' stroke='#1B1B1B'/></svg></button>",
responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2
        
      }
    },
    
    {
      breakpoint: 577,
      settings: {
        slidesToShow: 1
        
       
      }
    }
    
  ]       
     });
  }
 
  $(".collection-page-fact-h2").on("click",function(){
    $("#FacetsWrapperDesktop").toggleClass("active-flex-class");
    if($("#FacetsWrapperDesktop").hasClass("active-flex-class")){
      $("#FacetsWrapperDesktop details").first().find("summary").click();
    }
  });







var attrload =$('.select-variant-image').find(":selected").attr("class");
  $(".all-img img."+attrload).addClass("variant-select-img");
  setTimeout(function(){
  $(".all-img img."+attrload).parent().click();
    
    },500);
  $('.main-slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  accessibility: false,
  
    dots:false,
   infinite:false,
   
  asNavFor: '.small-slider',
    fade:true,
  
});
$('.small-slider').slick({
   slidesToShow: 4,
  slidesToScroll: 1,
  
  focusOnSelect: true,
  accessibility: false,
  
  arrows: true,
infinite:false,
  
  asNavFor: '.main-slider',
  vertical: true,
verticalSwiping: true,
  
  responsive: [
    {
      breakpoint: 992,
      settings: {
         vertical: false,
verticalSwiping: false,
          // arrows: false,
       
      }
    }
    
    
    ]
});  
  $(".main-slider").on("beforeChange", function (){
    $('.main-slider video').trigger('pause');
  });
  // setTimeout(function(){
  // $(".rc-widget").addClass("rc-widget-class-jq");
  //   },1000);
   $(".mainacc-deatils .first-accordian").next().slideDown();
  
$(document).on("click", ".acc-heading-h2", function() {
$(".acc-heading-h2").not(this).removeClass("active");
       $(this).toggleClass("active").next().slideToggle();
        $(".acc-desc-pdp").not($(this).next()).slideUp(300);
});
  setTimeout(function(){
    if($('.product .rc-widget').length < 1){
      $(".rechare-label-pdp").addClass("hidden");
    }
  },1000);
  setTimeout(function(){
    if($('.product .rc-widget').length < 1){
      $(".rechare-label-pdp").addClass("hidden");
    }
  },3400);
  setTimeout(function(){
    if($('.product .rc-widget').length < 1){
      $(".rechare-label-pdp").addClass("hidden");
    }
  },7000);
$(".facets-container .facet-filters__field .select__select").click(function(){
    if($("#FacetsWrapperDesktop").hasClass("active-flex-class")){
      $(".collection-page-fact-h2").click();
    }
})







 $('.edit_form').hide();
  $('.address_edit .edit').click(function(){
    $(".address_wrapper.edit_form").hide();
   //$(this).attr("aria-expanded","true");
   // $('.edit_form').show();
    $('.add_address_btn').attr("aria-expanded","false");
    
     $('#AddAddress').css("display","none");
    
    if($(this).attr("aria-expanded") != "true"){
      //alert("Y");
      
	$('.addresses #EditAddress_'+$(this).attr("data-address-id")).css("display","block");
     $(this).attr("aria-expanded","true");
    }
    else{
       $(this).attr("aria-expanded","false");
      $('.addresses #EditAddress_'+$(this).attr("data-address-id")).css("display","none");
    }
	
    
    
  });
  
  $('.edit_form .cancel').click(function(){
    
    $(this).closest('.edit_form').attr("aria-expanded","false")
    $(this).closest('.edit_form').prev('.address_inline').find('.address_edit .edit').attr("aria-expanded","false");
    
     // alert("Y");
	$(this).closest('.edit_form').css("display","none");
     
    
  });
  
  $('#AddAddress .cancel').click(function(){
    
    $(this).closest('#AddAddress').attr("aria-expanded","false");
    
    
     // alert("Y");
	$(this).closest('#AddAddress').css("display","none");
    
    
  });
   $('.add_address_btn').click(function(){
     
     if($(this).attr("aria-expanded") != "true"){
      //alert("Y");
	$('#AddAddress').css("display","block");
     
    }
    else{
      $('#AddAddress').css("display","none");
    }
     
     $('.address_edit .edit').attr("aria-expanded","false");
     $('.edit_form').css("display","none");
     
   });



// $(window).on("load", function() {
//     $("#preloader").fadeOut("slow");
//   $("body").removeClass("body-preloader-class");
// });
  if (window.location.href.indexOf("/cart") > -1) {
    window.location = "/";
  }
})